import "./PageSubsectionTitle.css";

const PageSubsectionTitle = (props) => {
  return(
    <div id={props.id} className="page-subsection-title">
      <span className="page-subsection-span">
        {props.children}
      </span>
    </div>
  );
}

export default PageSubsectionTitle;
